export const TIME_CONFIG = {
  SRI_LANKA_OFFSET_MINUTES: -330,
  SRI_LANKA_TIMEZONE: 'Asia/Colombo',
  SRI_LANKA_OFFSET_STRING: '+05:30',
  SYNC_INTERVAL_MS: 300000,
};

export default TIME_CONFIG;
